import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'
import CustomIcon from 'shared/components/customIcon'

import * as styles from './styles'

const MobileBalanceSectionComponent = ({
	currentBalance,
	currency = '$',
	onTopUpClick,
	isLoading = false,
}) => {
	// More robust loading detection
	const displayBalance = () => {
		if (isLoading) {
			return '...'
		}
		if (currentBalance === undefined) {
			return '...'
		}
		if (currentBalance === null) {
			return '...'
		}
		return currentBalance
	}

	return (
		<div css={styles.balanceContainer}>
			<div style={{ paddingBottom: '16px' }}>
				<Text size={16} bold css={styles.sectionTitle}>
					Balance management
				</Text>
			</div>

			{/* Merged Balance Card */}
			<div css={styles.mergedBalanceCard}>
				{/* Current Balance Section */}
				<div css={styles.currentBalanceSection}>
					<Text size={11} css={styles.balanceLabel}>
						Current Balance
					</Text>
					<Text size={12} bold css={styles.balanceAmount}>
						{currency}{displayBalance()}
					</Text>
				</div>

				{/* Divider */}
				<div css={styles.divider} />

				{/* Top Up Balance Section */}
				<button type="button" css={styles.topUpSection} onClick={onTopUpClick}>
					<Text size={11} css={styles.topUpLabel}>
						Top Up Balance
					</Text>
					<CustomIcon
						icon="angleRight"
						css={styles.arrowIcon}
						size={20}
					/>
				</button>
			</div>
		</div>
	)
}

MobileBalanceSectionComponent.propTypes = {
	currentBalance: PropTypes.number,
	currency: PropTypes.string,
	onTopUpClick: PropTypes.func,
	isLoading: PropTypes.bool,
}

export default MobileBalanceSectionComponent 
